export const WORKSPACE_TYPES = {
  EXERCISE: 'exercise',
  INCIDENT: 'incident',
  // Organization (group) scope — used by the org-level file library.
  ORG: 'organization',
} as const;

export type WorkspaceType =
  (typeof WORKSPACE_TYPES)[keyof typeof WORKSPACE_TYPES];
